export default [
  'none',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '-2px -2px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 10px 0px #00000040',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)',
  '0px 4px 4px rgba(0, 0, 0, 0.1)'
];
